<div class="flex flex-col flex-auto min-w-0">
    <div class="sm:inset-0 flex flex-col flex-auto min-w-0 sm:overflow-hidden bg-card dark:bg-transparent">
        <div class="flex flex-auto overflow-hidden">
            <div class="flex flex-col flex-auto sm:mb-18 overflow-hidden sm:overflow-y-auto">
                <div class="grid">
                    <div class="table-grid-equipements z-10 sticky top-0 grid gap-4 py-4 px-6 md:px-8 shadow text-md font-semibold text-secondary bg-gray-50 dark:bg-black dark:bg-opacity-5">
                        <div>Équipement</div>
                        <div>Piece</div>
                        <div>Date d'installation</div>
                        <div>Date de récupération</div>
                        <div class="text-right">Détails</div>
                    </div>
                    <ng-container *ngFor="let pieceEquipement of piecesEquipements; trackBy: trackByFn">
                        <div class="table-grid-equipements grid items-center gap-4 py-3 px-6 md:px-8 border-b">
                            <div class="">{{pieceEquipement.equipement?.no_equipement}}</div>
                            <div class="">{{getNomPiece(pieceEquipement)}}</div>
                            <div class="">{{pieceEquipement.date_installation}}</div>
                            <div class="">{{pieceEquipement.date_recuperation}}</div>
                            <div class="text-right">
                                <button class="min-w-10 min-h-7 h-7 px-2 leading-6" mat-stroked-button (click)="update(pieceEquipement)">
                                    <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:pencil'"></mat-icon>
                                </button>
                                <button class="min-w-10 min-h-7 h-7 px-2 leading-6" mat-stroked-button (click)="destroy(pieceEquipement)" *ngIf="isAdmin">
                                    <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:trash'"></mat-icon>
                                </button>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>
